// currency-conversion.util.ts

export const conversionRates = {
    pesos: 1,
    miles: 1000,
    millones: 1000000,
};

export function convertValue(
    value: number,
    currentRate: number,
    newRate: number
): number {
    if (value != null) {
        return (value * currentRate) / newRate;
    }
    return value;
}

export function convertValues(
    products: any[],
    currentCurrency: string,
    newCurrency: string
) {
    const currentRate = conversionRates[currentCurrency];
    const newRate = conversionRates[newCurrency];

    products.forEach((product) => {
        product.precioVenta = convertValue(
            product.precioVenta,
            currentRate,
            newRate
        );
    });
}
